import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'trg-card-list',
  templateUrl: './trg-card-list.component.html',
  styleUrls: ['./trg-card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SharedTrgCardListComponent {
  constructor() { }
}
